<template>
  <div
    class="aj-card"
    :class="classObject"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AjCard',

  props: {
    shadow: {
      type: Boolean,
      default: false,
    },
    tile: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classObject () {
      return {
        '-shadow': this.shadow,
        '-tile': this.tile,
      };
    },
  },
};
</script>

<style lang="scss" src="./AjCard.scss" scoped />
